var React = require('react');

function WorkshopsPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"workshops","fill":"none","stroke":"rgb(250,250,240)","strokeWidth":"2","d":"M0,383.08c114.4,4.52,252-40,412.4-174.67,461.3-387.08,714.92-94.47,1028.93-192.54"}));
}

WorkshopsPath.defaultProps = {"viewBox":"0 0 1441.67 384.39"};

module.exports = WorkshopsPath;

WorkshopsPath.default = WorkshopsPath;
